<template>
    <div v-if="showVerticalMenu" id="vMenu">
        <b-list-group-item
            :href="menuRoutes['budget-forecast-company']"
            class="item"
            :active="pageName === 'budget-forecast-company'"
            @click="setPageName('budget-forecast-company')"
        >
            <i class="fa-fw fal fa-table menu-sub-icon"></i>Forecast par cabinet
        </b-list-group-item>
        <b-list-group-item
            :href="menuRoutes['budget-forecast-activity']"
            class="item"
            :active="pageName === 'budget-forecast-activity'"
            @click="setPageName('budget-forecast-activity')"
        >
            <i class="fa-fw fal fa-table menu-sub-icon"></i>Forecast par
            activité
        </b-list-group-item>
        <b-list-group-item
            :href="menuRoutes['budget-forecast-client']"
            class="item"
            :active="pageName === 'budget-forecast-client'"
            @click="setPageName('budget-forecast-client')"
        >
            <i class="fa-fw fal fa-table menu-sub-icon"></i>Forecast par client
        </b-list-group-item>

        <b-list-group-item
            :href="menuRoutes['budget-rolling-interactive']"
            class="item"
            :active="pageName === 'budget-rolling-interactive'"
            @click="setPageName('budget-rolling-interactive')"
        >
            <i class="fa-fw fal fa-table menu-sub-icon"></i>Rolling interactif
        </b-list-group-item>
        <b-list-group-item
            :href="menuRoutes['budget-rolling-pivot']"
            class="item"
            :active="pageName === 'budget-rolling-pivot'"
            @click="setPageName('budget-rolling-pivot')"
        >
            <i class="fa-fw fal fa-table menu-sub-icon"></i>Rolling TCD
        </b-list-group-item>
        <!--
        <b-list-group-item :href="this.menuRoutes['budget-rolling-company']"
                           class="item"
                           :active="this.pageName==='budget-rolling-company'"
                           @click="setPageName('budget-rolling-company')">
            <i class="fa-fw fal fa-table menu-sub-icon"></i>Rolling par cabinet
        </b-list-group-item>
        <b-list-group-item :href="this.menuRoutes['budget-rolling-activity']"
                           class="item"
                           :active="this.pageName==='budget-rolling-activity'"
                           @click="setPageName('budget-rolling-activity')">
            <i class="fa-fw fal fa-table menu-sub-icon"></i>Rolling par activité
        </b-list-group-item>
        <b-list-group-item :href="this.menuRoutes['budget-rolling-client']"
                           class="item"
                           :active="this.pageName==='budget-rolling-client'"
                           @click="setPageName('budget-rolling-client')">
            <i class="fa-fw fal fa-table menu-sub-icon"></i>Rolling par client
        </b-list-group-item>
        -->
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'BudgetDashboardVerticalMenu',

    props: {
        page: '',
    },

    data() {
        return {
            openBalance: false,
            activeBalance: '',
            openBudget: false,
            activeBudget: '',
            openFees: false,
            activeFees: '',
            openEvolution: false,
            activeEvolution: '',
            openBilledVsReal: false,
            activeBilledVsReal: '',
            openImportation: false,
            activeImportation: '',
        }
    },

    async created() {
        await this.$store.dispatch('dashboardVM/getRoutes')
        this.$store.commit('dashboardVM/SHOW_VERTICAL_MENU')
        this.handleBalanceMenu()
        this.handleBudgetMenu()
        this.handleFeesMenu()
        this.handleEvolutionMenu()
        this.handleBilledVsRealMenu()
        this.handleImportationMenu()
    },

    methods: {
        setPageName(pageName) {
            this.$store.commit('browsing/SET_PAGE_NAME', pageName)
        },
        handleBalanceMenu() {
            this.openBalance = [
                'balance-global',
                'balance-user',
                'balance-state',
            ].includes(this.page)
            this.activeBalance = this.openBalance ? 'active' : ''
        },
        handleBudgetMenu() {
            this.openBudget = [
                'budget-forecast-company',
                'budget-forecast-client',
                'budget-forecast-activity',
                'budget-rolling-company',
                'budget-rolling-activity',
                'budget-rolling-client',
                'budget-rolling-interactive',
                'budget-rolling-pivot',
            ].includes(this.page)
            this.activeBudget = this.openBudget ? 'active' : ''
        },
        handleFeesMenu() {
            this.openFees = ['fees-interactive', 'fees-pivot'].includes(
                this.page
            )
            this.activeFees = this.openFees ? 'active' : ''
        },
        handleEvolutionMenu() {
            this.openEvolution = [
                'evolution-interactive',
                'evolution-pivot',
            ].includes(this.page)
            this.activeEvolution = this.openEvolution ? 'active' : ''
        },
        handleBilledVsRealMenu() {
            this.openBilledVsReal = [
                'billed-vs-real-interactive',
                'billed-vs-real-pivot',
            ].includes(this.page)
            this.activeBilledVsReal = this.openBilledVsReal ? 'active' : ''
        },
        handleImportationMenu() {
            this.openImportation = ['import-budget', 'import-fees'].includes(
                this.page
            )
            this.activeImportation = this.openImportation ? 'active' : ''
        },
    },

    computed: {
        ...mapState({
            pageName: (state) => state.browsing.pageName,
            showVerticalMenu: (state) => state.dashboardVM.showVerticalMenu,
            menuRoutes: (state) => state.dashboardVM.menuRoutes,
        }),
    },
}
</script>

<style scoped></style>
